// https://lucide.dev/guide/lucide/getting-started
// Recommended way, to include only the icons you need.
import {
    createIcons,
    Brain,
    HandHeart,
    Handshake,
    Heart,
    Baby,
    PartyPopper,
    Smile,
    Lightbulb,
    BicepsFlexed,
    Goal,
    BookText,
    HeartHandshake,
    Scale } from 'lucide';

createIcons({
  icons: {
    Brain,
    HandHeart,
    Handshake,
    Heart,
    Baby,
    PartyPopper,
    Smile,
    Lightbulb,
    BicepsFlexed,
    Goal,
    BookText,
    HeartHandshake,
    Scale
  }
});